<ng-container *ngIf="currentStep === 0">
  <section class="onboarding-screen">
    <div class="cg-flex">
      <div class="cg-flex-item-equal-width left-panel">
        <h2 class="cg-h2">Welcome {{ firstName }}</h2>
        <p class="cg-h3">
          You have an important role as a website access manager.
        </p>
        <p>Here is some information to help you better understand your role.</p>
        <p>
          If you are already familiar with your role, or you do not have any
          users to manage, you can dismiss this tutorial.
        </p>
        <p><i>Time commitment: Less than five minutes</i></p>

        <button
          cignaButton="primary"
          (click)="continueOnboarding()"
          class="cg-margin-right-md cg-margin-top-xxl"
        >
          Get Started
        </button>
        <button cignaButton="secondary" (click)="dismissConfirm()">
          Remind me later
        </button>
      </div>
      <div class="cg-flex-item-equal-width" style="display: inline-flex">
        <img
          [src]="
            'assets/images/wam-onboarding/step-0-' + appContext + '.jpg'
              | cdnPrefix
          "
          alt="wam onboarding welcome"
          width="656"
          height="560"
        />
      </div>
    </div>
  </section>
</ng-container>
<ng-container *ngIf="currentStep > 0">
  <cigna-wam-onboarding-step
    [currentStep]="currentStep"
    [appContext]="appContext"
    (dismiss)="dismissConfirm()"
    (continueOnboarding)="continueOnboarding()"
    (completeOnboarding)="completeOnboarding()"
    (previousOnboarding)="previous()"
  ></cigna-wam-onboarding-step>
</ng-container>

<ng-template #dismissModal>
  <div class="cg-dialog">
    <button
      cignaButton="link inline no-underline"
      class="cg-dialog__close"
      (click)="dialogRef.close()"
    >
      Close
      <cigna-icon class="cml-close-icon" type="close-thin"></cigna-icon>
    </button>
    <h3 class="cg-dialog__header cg-dialog__header--modal">
      Website Access Manager Information
    </h3>

    <mat-dialog-content>
      <ng-container *ngIf="onboardingStatus === 'false'; else firstView">
        <p>
          This information is always available for you on the website access
          manager resource page.
        </p>
        <button cignaButton="primary" (click)="completeOnboarding()">
          Continue to dashboard
        </button>
      </ng-container>
      <ng-template #firstView>
        <p>This information will appear once more the next time you log in.</p>

        <div class="cg-margin-bottom-md">
          <label>
            <input id="dontShowBox" type="checkbox" /> Do not show me this again
          </label>
        </div>

        <button cignaButton="primary" (click)="skipOnboarding()">
          Continue to dashboard
        </button>
      </ng-template>
    </mat-dialog-content>
  </div>
</ng-template>
